{
	"name": "peerjs",
	"version": "1.4.6",
	"keywords": [
		"peerjs",
		"webrtc",
		"p2p",
		"rtc"
	],
	"description": "PeerJS client",
	"homepage": "https://peerjs.com",
	"bugs": {
		"url": "https://github.com/peers/peerjs/issues"
	},
	"repository": {
		"type": "git",
		"url": "https://github.com/peers/peerjs"
	},
	"license": "MIT",
	"contributors": [
		"Michelle Bu <michelle@michellebu.com>",
		"afrokick <devbyru@gmail.com>",
		"ericz <really.ez@gmail.com>",
		"Jairo <kidandcat@gmail.com>",
		"Jonas Gloning <34194370+jonasgloning@users.noreply.github.com>",
		"Jairo Caro-Accino Viciana <jairo@galax.be>",
		"Carlos Caballero <carlos.caballero.gonzalez@gmail.com>",
		"hc <hheennrryy@gmail.com>",
		"Muhammad Asif <capripio@gmail.com>",
		"PrashoonB <prashoonbhattacharjee@gmail.com>",
		"Harsh Bardhan Mishra <47351025+HarshCasper@users.noreply.github.com>",
		"akotynski <aleksanderkotbury@gmail.com>",
		"lmb <i@lmb.io>",
		"Jairooo <jairocaro@msn.com>",
		"Moritz Stückler <moritz.stueckler@gmail.com>",
		"Simon <crydotsnakegithub@gmail.com>",
		"Denis Lukov <denismassters@gmail.com>",
		"Philipp Hancke <fippo@andyet.net>",
		"Hans Oksendahl <hansoksendahl@gmail.com>",
		"Jess <jessachandler@gmail.com>",
		"khankuan <khankuan@gmail.com>",
		"DUODVK <kurmanov.work@gmail.com>",
		"XiZhao <kwang1imsa@gmail.com>",
		"Matthias Lohr <matthias@lohr.me>",
		"=frank tree <=frnktrb@googlemail.com>",
		"Andre Eckardt <aeckardt@outlook.com>",
		"Chris Cowan <agentme49@gmail.com>",
		"Alex Chuev <alex@chuev.com>",
		"alxnull <alxnull@e.mail.de>",
		"Yemel Jardi <angel.jardi@gmail.com>",
		"Ben Parnell <benjaminparnell.94@gmail.com>",
		"Benny Lichtner <bennlich@gmail.com>",
		"fresheneesz <bitetrudpublic@gmail.com>",
		"bob.barstead@exaptive.com <bob.barstead@exaptive.com>",
		"chandika <chandika@gmail.com>",
		"emersion <contact@emersion.fr>",
		"Christopher Van <cvan@users.noreply.github.com>",
		"eddieherm <edhermoso@gmail.com>",
		"Eduardo Pinho <enet4mikeenet@gmail.com>",
		"Evandro Zanatta <ezanatta@tray.net.br>",
		"Gardner Bickford <gardner@users.noreply.github.com>",
		"Gian Luca <gianluca.cecchi@cynny.com>",
		"PatrickJS <github@gdi2290.com>",
		"jonnyf <github@jonathanfoss.co.uk>",
		"Hizkia Felix <hizkifw@gmail.com>",
		"Hristo Oskov <hristo.oskov@gmail.com>",
		"Isaac Madwed <i.madwed@gmail.com>",
		"Ilya Konanykhin <ilya.konanykhin@gmail.com>",
		"jasonbarry <jasbarry@me.com>",
		"Jonathan Burke <jonathan.burke.1311@googlemail.com>",
		"Josh Hamit <josh.hamit@gmail.com>",
		"Jordan Austin <jrax86@gmail.com>",
		"Joel Wetzell <jwetzell@yahoo.com>",
		"xizhao <kevin.wang@cloudera.com>",
		"Alberto Torres <kungfoobar@gmail.com>",
		"Jonathan Mayol <mayoljonathan@gmail.com>",
		"Jefferson Felix <me@jsfelix.dev>",
		"Rolf Erik Lekang <me@rolflekang.com>",
		"Kevin Mai-Husan Chia <mhchia@users.noreply.github.com>",
		"Pepijn de Vos <pepijndevos@gmail.com>",
		"JooYoung <qkdlql@naver.com>",
		"Tobias Speicher <rootcommander@gmail.com>",
		"Steve Blaurock <sblaurock@gmail.com>",
		"Kyrylo Shegeda <shegeda@ualberta.ca>",
		"Diwank Singh Tomer <singh@diwank.name>",
		"Sören Balko <Soeren.Balko@gmail.com>",
		"Arpit Solanki <solankiarpit1997@gmail.com>",
		"Yuki Ito <yuki@gnnk.net>",
		"Artur Zayats <zag2art@gmail.com>"
	],
	"funding": {
		"type": "opencollective",
		"url": "https://opencollective.com/peer"
	},
	"collective": {
		"type": "opencollective",
		"url": "https://opencollective.com/peer"
	},
	"files": [
		"dist/*"
	],
	"type": "module",
	"sideEffects": [
		"lib/global.ts",
		"lib/supports.ts"
	],
	"main": "dist/bundler.cjs",
	"module": "dist/bundler.mjs",
	"browser-minified": "dist/peerjs.min.cjs",
	"browser-unminified": "dist/peerjs.cjs",
	"types": "dist/types.d.ts",
	"engines": {
		"node": ">= 10"
	},
	"targets": {
		"types": {
			"source": "lib/exports.ts"
		},
		"main": {
			"source": "lib/exports.ts",
			"sourceMap": {
				"inlineSources": true
			}
		},
		"module": {
			"source": "lib/exports.ts",
			"includeNodeModules": [
				"eventemitter3"
			],
			"sourceMap": {
				"inlineSources": true
			}
		},
		"browser-minified": {
			"includeNodeModules": true,
			"context": "browser",
			"optimize": true,
			"engines": {
				"browsers": "cover 99%, not dead"
			},
			"source": "lib/global.ts"
		},
		"browser-unminified": {
			"includeNodeModules": true,
			"context": "browser",
			"optimize": false,
			"engines": {
				"browsers": "cover 99%, not dead"
			},
			"source": "lib/global.ts"
		}
	},
	"scripts": {
		"contributors": "git-authors-cli --print=false && prettier --write package.json && git add package.json package-lock.json && git commit -m \"chore(contributors): update and sort contributors list\"",
		"check": "tsc --noEmit",
		"watch": "parcel watch",
		"build": "rm -rf dist && parcel build && cp dist/peerjs.cjs dist/peerjs.js && cp dist/peerjs.min.cjs dist/peerjs.min.js",
		"prepublishOnly": "npm run build",
		"test": "mocha -r ts-node/register -r jsdom-global/register test/**/*.ts",
		"format": "prettier --write .",
		"semantic-release": "semantic-release"
	},
	"devDependencies": {
		"@parcel/config-default": "^2.5.0",
		"@parcel/packager-ts": "^2.5.0",
		"@parcel/transformer-typescript-tsc": "^2.5.0",
		"@parcel/transformer-typescript-types": "^2.5.0",
		"@semantic-release/changelog": "^6.0.1",
		"@semantic-release/git": "^10.0.1",
		"@types/chai": "^4.3.0",
		"@types/mocha": "^9.1.0",
		"@types/node": "^17.0.18",
		"chai": "^4.3.6",
		"git-authors-cli": "^1.0.40",
		"jsdom": "^19.0.0",
		"jsdom-global": "^3.0.2",
		"mocha": "^9.2.0",
		"mock-socket": "8.0.5",
		"parcel": "^2.5.0",
		"parcel-transformer-tsc-sourcemaps": "^1.0.2",
		"prettier": "^2.6.2",
		"semantic-release": "^19.0.2",
		"standard": "^16.0.4",
		"ts-node": "^10.5.0",
		"typescript": "^4.5.5"
	},
	"dependencies": {
		"@swc/helpers": "^0.3.13",
		"eventemitter3": "^4.0.7",
		"peerjs-js-binarypack": "1.0.1",
		"webrtc-adapter": "^7.7.1"
	}
}
